// indexedDBStorage.js
import { openDB } from "idb";

const DB_NAME = "app-storage";
const STORE_NAME = "persistedState";

const dbPromise = openDB(DB_NAME, 1, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(STORE_NAME)) {
      db.createObjectStore(STORE_NAME);
    }
  },
});

export const indexedDBStorage = {
  async getItem(key) {
    const db = await dbPromise;
    return (await db.get(STORE_NAME, key)) ?? null;
  },
  async setItem(key, value) {
    const db = await dbPromise;
    await db.put(STORE_NAME, value, key);
  },
  async removeItem(key) {
    const db = await dbPromise;
    await db.delete(STORE_NAME, key);
  },
};
